import React from 'react';
import { IconType } from 'react-icons';

import useNavigationIcon from './navigation-icon.controller';

const ID = 'navigation-icon';
export interface NavigationIconProps {
    text?: React.ReactNode;
    link: string;
    icon: IconType;

    styles?: NavigationIconStyles;
    disabled?: boolean;
}

//todo
export interface NavigationIconStyles {}

export const NavigationIcon = (props: NavigationIconProps) => {
    const viewProps = useNavigationIcon(props);

    return (
        <div
            id={ID}
            data-variant={props.text ?? props.link}
            onClick={viewProps.onNavigate}
            className={`${props.disabled ? 'text-brand-disabled' : (viewProps.highlighted ? 'text-brand-primary' : 'text-foreground-default')} w-20 inline-flex flex-col justify-center items-center gap-1`}>
            <div className='w-5 h-5'>
                <props.icon className='size-full' />
            </div>
            <div className="text-center justify-start text-sm font-medium ">{props.text ?? props.link}</div>
        </div>
    );
};
